{
  "add_innovations.cancel_cta": "Annuler",
  "add_innovations.do_not_overwrite": "(La première ligne du fichier ne doit pas être éditée)",
  "add_innovations.download_example": "Téléchargez un exemple de fichier CSV",
  "add_innovations.ean_fields": "EAN",
  "add_innovations.import_button": "Importer une liste (.csv)",
  "add_innovations.save_button": "Sauvegarder ces innovations",
  "add_innovations.search_placeholder": "Tapez au moins 4 lettres pour filtrer les résultats",
  "add_innovations.success_toaster": "Vos innovations ont bien été rajoutées",
  "add_innovations.unknown_list_plural_and_other": "et {{variable2}} autre",
  "add_innovations.unknown_list_plural_and_others": "et {{variable2}} autres",
  "add_innovations.unknown_list_plural": "Les références {{variable1}} n'ont pas de donnée car elles ne sont pas encore vendues ou sont peut être erronées.",
  "add_innovations.unknown_list_singular": "La référence {{variable}} n'a pas de donnée car elle n'est pas encore vendue ou est peut être erronée.",
  "common_label.error_data": "-",
  "common_label.error_message": "Une erreur inconnue a empêché le chargement de cette page.",
  "delete_cta": "Supprimer",
  "delete_toaster_info": "L'innovation a bien été supprimée",
  "error_page.back_button": "Retourner au Suivi d'innovations",
  "error_page.generic_subtitle": "Il se peut que cette page n'existe pas, qu'elle ait été supprimée, ou que vous n'ayez pas les autorisations nécessaires. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter votre administrateur.",
  "error_page.generic_title": "Vous n'avez pas accès à cette page",
  "error_page.no_access_subtitle": "Si vous pensez qu'il s'agit d'une erreur, veuillez contacter votre administrateur.",
  "error_page.no_access_title": "Vous n'avez pas accès au module de Suivi d'innovations",
  "inno_navbar.gitbook_button": "Contactez nous",
  "inno_navbar.gitbook_tooltip": "Accéder au support utilisateur",
  "inno_navbar.module_name": "Suivi d'innovations",
  "inno_navbar.title": "Carrefour Links",
  "inno_navbar.utilities": "Services",
  "inno_page_subtitle": "Maximisez la performance de vos innovations et adaptez votre stratégie.",
  "inno_page_table_name": "Vos innovations",
  "inno_page_title": "Suivi d'innovations",
  "inno_page.add_button": "Ajouter vos innovations",
  "inno_page.date_selector_apply": "Appliquer la sélection",
  "inno_page.date_selector_end": "Date de fin",
  "inno_page.date_selector_start": "Date de début",
  "inno_page.date_selector_title": "Intervalle de dates d'analyse",
  "inno_page.export_button": "Exporter en csv",
  "inno_page.export_no_data_warning": "Aucune donnée disponible à l'export",
  "inno_page.format_filters_all": "Tous les formats",
  "inno_page.format_filters_format": "Formats",
  "inno_page.supplier_filters_all": "Tous les fournisseurs",
  "inno_page.supplier_filters": "Fournisseurs",
  "inno_reporting_email.cta_link": "Accéder aux données de performance",
  "inno_reporting_email.period_reminder_from": "De",
  "inno_reporting_email.period_reminder_launch_date": "la date de lancement",
  "inno_reporting_email.period_reminder_subtitle_previous": "à la semaine précédente",
  "inno_reporting_email.period_reminder_subtitle": "Evolution par rapport",
  "inno_reporting_email.period_reminder_to": "au",
  "inno_reporting_email.table_column_detention": "Détention sur vente",
  "inno_reporting_email.table_column_EAN": "Innovation",
  "inno_reporting_email.table_column_VMH": "VMH /  Objectif",
  "inno_reporting_email.table_title": "Vos innovations - Evolutions par rapport à la semaine dernière",
  "inno_reporting_email.title": "Reporting hebdomadaire de vos innovations",
  "inno_reporting_email.top_flop_detention.title": "Principales évolutions de la détention par rapport à la semaine dernière",
  "inno_reporting_email.top_flop_sales.subtitle": "VMH depuis le lancement",
  "inno_reporting_email.top_flop_sales.title": "Principales évolutions par rapport à la semaine dernière (quantité)",
  "inno_reporting_email.top_flop_since_last_week": "depuis la semaine dernière",
  "inno_topbar.logout_button": "Déconnexion",
  "listing_table_column_name_ean": "EAN",
  "listing_table_column_name_format": "Format",
  "listing_table_column_name_goal": "Atteinte objectif",
  "listing_table_column_name_label": "Libellé",
  "listing_table_column_name_launch_date": "Date de Lancement",
  "listing_table_column_name_posession_rate": "Taux de détention sur ventes",
  "listing_table_column_name_product_name": "Libellé",
  "listing_table_column_name_subfam_weekly_sales": "VMH moyenne de la sous-famille",
  "listing_table_column_name_supplier": "Fournisseur",
  "listing_table_column_name_weekly_sales": "VMH",
  "monitoring_page.back_button": "Retour à votre liste d'innovations",
  "monitoring_page.graph.copy_image_message": "Copié avec succès dans votre presse-papier",
  "monitoring_page.graph.copy_image": "Copier l'image",
  "monitoring_page.graph.extract_csv": "Extraire les données (csv)",
  "monitoring_page.graph.legend_innovation": "VMH (quantité)",
  "monitoring_page.graph.legend_possesion_rate": "Taux de détention sur vente (%)",
  "monitoring_page.graph.legend_subclass": "VMH moyenne sous-famille (quantité)",
  "monitoring_page.graph.save_image": "Exporter (PNG)",
  "monitoring_page.graph.title": "Performance de l'innovation",
  "monitoring_page.internal_search_field": "Rechercher par EAN ou libellé",
  "monitoring_page.internal_search_no_result": "Pas de résultat pour",
  "monitoring_page.metadata_date_perimeter": "Du {{launchDate}} au {{today}}",
  "monitoring_page.metadata_launchdate": "Lancé le",
  "monitoring_page.no_target_quantity": "Cette innovation n'a pas de donnée disponible concernant sa VMH cible.",
  "monitoring_page.not_shared_with_alert": "Vue interne seulement",
  "monitoring_page.objective_card_description": "VMH (UVC): {{averageWeeklySalesQuantity}}/{{averageWeeklySalesQuantityGoal}}",
  "monitoring_page.objective_card_title": "Vous avez atteint {{achieved_objective_percent}} de votre objectif",
  "monitoring_page.shared_with_alert": "Partagé avec {supplier_name}",
  "monitoring_page.store_detention_alert_export": "Extraire la liste en CSV ({{store_count}})",
  "monitoring_page.store_detention_alert_plural": "magasins ne détiennent pas votre innovation",
  "monitoring_page.store_detention_alert_singular": "magasin ne détient pas votre innovation",
  "monitoring_page.tab_name_quant": "Quantité",
  "monitoring_page.tab_name_value": "CA TTC",
  "monitoring_page.tabs.quant.left_side_objective": "Objectif",
  "monitoring_page.tabs.quant.left_side_title": "VMH (UVC)",
  "monitoring_page.tabs.quant.right_side_non_promo": "Hors promo",
  "monitoring_page.tabs.quant.right_side_promo": "Promo.",
  "monitoring_page.tabs.quant.right_side_title": "Total depuis lancement",
  "monitoring_page.tabs.value_right_side_title": "Total depuis lancement (CA TTC)",
  "monitoring_page.tabs.value.left_side_title": "VMH (CA TTC)",
  "monitoring_page.tabs.value.right_side_non_promo": "Promo.",
  "monitoring_page.tabs.value.right_side_promo": "Hors promo",
  "unsubscribe_page.cta_confirm": "Confirmer le désabonnement",
  "unsubscribe_page.main_subtext": "Vous pouvez vous réabonner à tout moment en contactant notre équipe support.",
  "unsubscribe_page.main_text": "Vous êtes sur le point de vous désabonner du reporting hebdomadaire d'innovations",
  "unsubscribe_page.question": "Une question?",
  "unsubscribe_page.successful_text": "Vous êtes bien désabonné(e) du reporting hedbomadaire d'innovations",
  "unsubscribe_page.support": "Contacter notre équipe support"
}
